/* Kickson — general UI behavior (drawers, gallery, filters, variant availability).
   No cart mutation here — see cart.js. */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function lockBody() { document.body.classList.add('is-locked'); }
  function unlockBody() {
    if (!qs('.mobile-menu.is-open') && !qs('.cart-drawer.is-open') && !qs('.search-drawer.is-open') && !qs('.collection-filters.is-open')) {
      document.body.classList.remove('is-locked');
    }
  }

  /* ---- Search drawer (supports multiple open triggers: header + mobile menu) --- */
  function initSearchDrawer() {
    var drawer = qs('#SearchDrawer');
    var openBtns = qsa('[data-search-toggle]');
    var closeBtn = drawer && qs('[data-search-close]', drawer);
    if (!drawer || !openBtns.length) return;

    function open() {
      var menu = qs('#MobileMenu.is-open');
      if (menu) {
        var menuClose = qs('[data-menu-close]', menu);
        if (menuClose) menuClose.click();
      }
      drawer.hidden = false;
      lockBody();
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var input = qs('[data-predictive-search-input]', drawer);
      if (input) window.setTimeout(function () { input.focus(); }, 300);
    }
    function close() {
      drawer.classList.remove('is-open');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      window.setTimeout(function () { drawer.hidden = true; unlockBody(); }, 350);
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---- Predictive search (debounced fetch against Shopify's Search API) --- */
  function initPredictiveSearch() {
    var input = qs('[data-predictive-search-input]');
    var results = qs('[data-predictive-search-results]');
    if (!input || !results) return;
    var timer;
    var controller;

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,product_type', { signal: controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="empty-state">No results for &ldquo;' + term.replace(/</g, '&lt;') + '&rdquo;</p>';
              return;
            }
            var html = products.map(function (p) {
              return '<a class="predictive-result" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" width="48" height="48" loading="lazy">' : '') +
                '<span>' + p.title + (p.price ? ' &mdash; ' + p.price : '') + '</span></a>';
            }).join('');
            html += '<a class="btn btn--ghost search-drawer__view-all" href="/search?q=' + encodeURIComponent(term) + '&type=product">View all results</a>';
            results.innerHTML = html;
          })
          .catch(function () { /* fail quietly, full /search page remains available on submit */ });
      }, 220);
    });
  }

  /* ---- Product gallery (modern slider) -------------------------------------- */
  function initGallery() {
    qsa('[data-product-gallery]').forEach(function (gallery) {
      var track = qs('[data-gallery-scroll]', gallery);
      var slides = qsa('[data-gallery-slide]', gallery);
      var thumbs = qsa('[data-gallery-thumb]', gallery);
      var dots = qsa('[data-dot]', gallery);
      var prevBtn = qs('[data-gallery-prev]', gallery);
      var nextBtn = qs('[data-gallery-next]', gallery);
      var counter = qs('[data-current-slide]', gallery);
      
      if (!track || slides.length === 0) return;
      
      var currentIndex = 0;
      var slideCount = slides.length;
      
      function goToSlide(index) {
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;
        currentIndex = index;
        
        var slideWidth = track.offsetWidth;
        track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
        
        // Update thumbnails
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
        });
        
        // Update dots
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        
        // Update slides
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        
        // Update counter
        if (counter) counter.textContent = (index + 1);
      }
      
      // Arrow navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex - 1);
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex + 1);
        });
      }
      
      // Thumbnail clicks
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.getAttribute('data-index'), 10);
          goToSlide(index);
        });
      });
      
      // Dot clicks
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-dot'), 10);
          goToSlide(index);
        });
      });
      
      // Update on scroll (for touch swipe)
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var slideWidth = track.offsetWidth;
          var newIndex = Math.round(track.scrollLeft / slideWidth);
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slideCount) {
            currentIndex = newIndex;
            
            thumbs.forEach(function (thumb, i) {
              thumb.classList.toggle('is-active', i === currentIndex);
            });
            dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === currentIndex);
            });
            slides.forEach(function (slide, i) {
              slide.classList.toggle('is-active', i === currentIndex);
            });
            if (counter) counter.textContent = (currentIndex + 1);
          }
        }, 50);
      });
      
      // Keyboard navigation
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goToSlide(currentIndex - 1);
        if (e.key === 'ArrowRight') goToSlide(currentIndex + 1);
      });
    });
  }

  /* ---- Collection filters (mobile bottom sheet) ------------------------------- */
  function initFilters() {
    var toggle = qs('[data-filters-toggle]');
    var panel = qs('[data-filters]');
    if (!toggle || !panel) return;
    var closeBtns = qsa('[data-filters-close]', panel);

    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      lockBody();
    }
    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      unlockBody();
    }
    toggle.addEventListener('click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });

    // Native Shopify filtering: checkbox changes submit the enclosing filter form.
    qsa('[data-filter-input]', panel).forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit(); else window.location.reload();
      });
    });
  }

  /* ---- Variant availability for the size/option selector ---------------------- */
  function initVariantSelector() {
    var form = qs('#ProductForm');
    if (!form) return;
    var dataEl = qs('#ProductJson');
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variantIdInput = qs('[data-variant-id]', form);
    var priceEl = qs('[data-product-price] .price');
    var stickyPriceEl = qs('.sticky-atc .price');
    var addBtn = qs('[data-add-to-cart]', form);
    var optionInputs = qsa('[data-option-input]', form);

    function getSelected() {
      var selected = [];
      product.options.forEach(function (_, i) {
        var checked = qs('input[name="option-' + (i + 1) + '"]:checked', form);
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return selected[i] === null || val === selected[i]; });
      });
    }

    function refreshAvailability() {
      var selected = getSelected();
      optionInputs.forEach(function (input) {
        var position = parseInt(input.name.replace('option-', ''), 10) - 1;
        var testSelected = selected.slice();
        testSelected[position] = input.value;
        var possible = product.variants.some(function (v) {
          return v.available && v.options.every(function (val, i) {
            return testSelected[i] === null || val === testSelected[i];
          });
        });
        var wrapper = input.closest('.product-form__value');
        if (wrapper) wrapper.classList.toggle('is-unavailable', !possible);
        input.disabled = !possible && !input.checked;
      });

      var variant = findVariant(selected);
      if (variant) {
        variantIdInput.value = variant.id;
        if (variant.price) {
          var formatted = formatMoney(variant.price);
          if (priceEl) priceEl.textContent = formatted;
          if (stickyPriceEl) stickyPriceEl.textContent = formatted;
        }
        [addBtn, qs('.sticky-atc button[name="add"]')].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? 'Add to bag' : 'Sold out';
        });
        // Update gallery to show variant image
        if (variant.featured_media && variant.featured_media.id) {
          var thumb = qs('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]');
          if (thumb) thumb.click();
        }
        
        // Update selected color label
        var colorInput = qs('[data-color-option]:checked', form);
        if (colorInput) {
          var colorLabel = qs('[data-selected-color]');
          if (colorLabel) colorLabel.textContent = colorInput.value;
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }

    // Supports every Shopify money_format placeholder, so prices never render
    // as a raw "{{ amount_with_comma_separator }}" string.
    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      function withDelimiters(precision, thousands, decimal) {
        var value = (cents / 100).toFixed(precision);
        var parts = value.split('.');
        var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
        return parts[1] ? intPart + decimal + parts[1] : intPart;
      }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount': return withDelimiters(2, ',', '.');
          case 'amount_no_decimals': return withDelimiters(0, ',', '.');
          case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
          case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return withDelimiters(0, ' ', ',');
          case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
          default: return withDelimiters(2, ',', '.');
        }
      });
    }

    // Jump to variant image when color is selected
    function goToVariantImage(variant) {
      if (!variant || !variant.featured_media) return;
      var mediaId = variant.featured_media.id;
      var thumb = qs('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
      if (thumb) thumb.click();
    }
    
    // Listen for color option changes - jump to variant image
    var colorInputs = qsa('[data-color-option]', form);
    colorInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var selected = getSelected();
        var variant = findVariant(selected);
        goToVariantImage(variant);
        // Update color label
        var colorLabel = qs('[data-selected-color]');
        if (colorLabel) colorLabel.textContent = input.value;
      });
    });

    optionInputs.forEach(function (input) { input.addEventListener('change', refreshAvailability); });
    refreshAvailability();
  }

  /* ---- Sticky mobile add-to-bag bar ------------------------------------------- */
  function initStickyAddToCart() {
    var bar = qs('[data-sticky-atc]');
    var formBtn = qs('[data-add-to-cart]');
    if (!bar || !formBtn || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Only reveal after the in-page button has scrolled *past* the top of the
        // viewport — never on load while it is still further down the page.
        var scrolledPast = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
      });
    }, { threshold: 0 });
    observer.observe(formBtn);
  }

  /* ---- Category slider: arrow nav + desktop click-drag (native scroll on touch) --- */
  function initCategorySlider() {
    qsa('[data-slider-track]').forEach(function (track) {
      var section = track.closest('.category-slider');
      var prevBtn = section && qs('[data-slider-prev]', section);
      var nextBtn = section && qs('[data-slider-next]', section);

      function cardWidth() {
        var card = track.querySelector('.category-card');
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: cardWidth(), behavior: 'smooth' }); });

      // Desktop click-and-drag. Touch devices keep native momentum scrolling untouched.
      if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('mousedown', function (e) {
        isDown = true; moved = false;
        startX = e.pageX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('mouseup', function () { isDown = false; track.classList.remove('is-dragging'); });
      track.addEventListener('mouseleave', function () { isDown = false; track.classList.remove('is-dragging'); });
      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var delta = e.pageX - startX;
        if (Math.abs(delta) > 4) moved = true;
        track.scrollLeft = startScroll - delta;
      });
      // Prevent an accidental card navigation when the drag was actually a drag, not a click.
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---- Product image zoom on hover (desktop) ---------------------------------- */
  function initProductZoom() {
    var gallery = document.querySelector('[data-gallery-main]');
    if (!gallery || window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

    gallery.addEventListener('click', function (e) {
      var img = e.target.closest('.product-page__gallery-item img');
      if (!img) return;
      if (img.classList.contains('is-zoomed')) {
        img.classList.remove('is-zoomed');
        img.style.removeProperty('--zoom-x');
        img.style.removeProperty('--zoom-y');
      } else {
        // Close any other zoomed images first
        var prev = gallery.querySelector('.is-zoomed');
        if (prev) prev.classList.remove('is-zoomed');
        var rect = img.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
        var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
        img.style.setProperty('--zoom-x', x + '%');
        img.style.setProperty('--zoom-y', y + '%');
        img.classList.add('is-zoomed');
      }
    });

    gallery.addEventListener('mousemove', function (e) {
      var img = e.target.closest('.product-page__gallery-item img.is-zoomed');
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
      var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
      img.style.setProperty('--zoom-x', x + '%');
      img.style.setProperty('--zoom-y', y + '%');
    });

    gallery.addEventListener('mouseleave', function () {
      var zoomed = gallery.querySelectorAll('.is-zoomed');
      zoomed.forEach(function (img) { img.classList.remove('is-zoomed'); });
    });
  }

  /* ---- Quantity stepper (−/+) ------------------------------------------------- */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-down], [data-qty-up]');
      if (!btn) return;
      var stepper = btn.closest('.qty-stepper');
      if (!stepper) return;
      var input = stepper.querySelector('[data-qty-field]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      if (btn.hasAttribute('data-qty-down')) {
        input.value = Math.max(min, current - 1);
      } else {
        input.value = current + 1;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSearchDrawer();
    initPredictiveSearch();
    initGallery();
    initFilters();
    initCategorySlider();
    initVariantSelector();
    initStickyAddToCart();
    initQtySteppers();
    initProductZoom();
  });
})();
